// extracted by mini-css-extract-plugin
export default {"searchTours":"Search_searchTours__LvRDj"};